'use client';

// Utils
import { Feature } from '@gql';

// UI
import { Button } from '@components/button';
import { Icon, mapFeatureKeyToIconName } from '@components/icon';
import { Typography } from '@components/typography';

type Props = {
  features: Pick<Feature, 'displayName' | 'key'>[];
  showAllEnabled: boolean;
  toggleShowAll: () => void;
};

export const FeaturesSection: React.FC<Props> = ({
  features,
  showAllEnabled,
  toggleShowAll,
}) => {
  const displayToggleButton = features.length > 12;
  const displayList = showAllEnabled ? features : features.slice(0, 11);
  const showText = showAllEnabled ? 'Show less' : 'Show more';
  return (
    <div className="-mb-2">
      <div className="grid gap-4 grid-cols-1 sm:grid-cols-2 xl:grid-cols-3">
        {displayList.map((feature, index) => (
          <div key={index} className="flex flex-row items-center">
            <Icon
              name={mapFeatureKeyToIconName(feature.key)}
              className="text-primary-main"
            />
            <Typography
              component="span"
              variant="body2"
              variantM="body1"
              className="ml-4 !font-light text-md"
            >
              {feature.displayName}
            </Typography>
          </div>
        ))}
      </div>
      {displayToggleButton && (
        <div className="flex flex-row justify-start">
          <Button
            size="md"
            onClick={toggleShowAll}
            variant="text"
            className="-ml-[16.5px] text-primary-main underline text-md font-medium mt-1"
          >
            {showText}
          </Button>
        </div>
      )}
    </div>
  );
};
